import React from 'react';
import { compose } from 'ramda';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import styleFile from '../../../views/customerForm/CustomerForm.js';
import Image from '@synergycms_core/components/generic/Image';
import { Icon, RichText } from '@synergycms_core/components/generic';
import Form from '@synergycms_core/components/generic/Form';
import InputNotify from '@synergycms_core/components/generic/Form/InputNotify';
import ButtonOverride from '@synergycms_core/components/generic/Form/ButtonOverride';
import ButtonSubmit from '@synergycms_core/components/generic/Form/ButtonSubmit';
import InputField from '@synergycms_core/components/generic/Form/InputField';
import connect from 'react-redux/es/connect/connect';
import { round, reservationAvailQuery } from '../../../utils';
import { set } from '@synergycms_core/utils';
import { List, Map } from 'immutable';
import actions from '../../../store/actions';
import Price from '@synergycms_core/components/generic/Price';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';

const customerActions = actions.customer;

const mapStateToProps = (store, ownProps) => {
  const hotelId = store.getIn(['customer', 'current_hotel']);
  const reservation = store.getIn(['customer', 'reservation']);
  const reservationBlocks = store.getIn(['customer', 'reservation_request', 'blocks']);
  const queryParams = store.getIn(['hotels', hotelId, 'params', 'query_params']);

  const hotelAvail = store.getIn([
    'avail',
    hotelId,
    store.getIn(['hotels', hotelId, 'params', reservationAvailQuery(store).get("string_params")]),
    'response'
  ]);
  const amountPromoPaid = reservation.getIn(['payment', 'amount_promo_paid'], 0);
  const promoDescription = amountPromoPaid > 0 && ownProps.type === 'gift_voucher' && reservation.getIn(['gift_voucher', 'description'], false);

  let promoCodePercentDiscount = null;
  const hasPromoCode = queryParams && (queryParams.get('promotion_code') || queryParams.get('avail_code'));
  if (hasPromoCode && hotelAvail && reservationBlocks) {
    const promoCodeAmountDiscount = reservationBlocks.reduce((value, block, idx) => {
      const selectedRateAvail = hotelAvail.getIn([
        idx,
        block.get('room_id'),
        'boards',
        block.get('board_id'),
        block.get('ref_type')
      ]);

      const findDiscount =
        selectedRateAvail &&
        selectedRateAvail.get('discounts', List()).find(discount => {
          return discount.get('is_promotion_code');
        });
      return value + (findDiscount && Math.abs(findDiscount.get('amount', 0))) || 0;
    }, 0);
    promoCodePercentDiscount = round(
      (promoCodeAmountDiscount * 100) / (reservation.get('total_price_tax') + promoCodeAmountDiscount),
      0
    );
  }

  const corporateStore = store.getIn(['customer', 'corporate']) || Map();
  const companyCode = corporateStore.get('afiliado', false) || corporateStore.get('avail_code', false) || false;
  
  const isNotFinallyConfirmed = !(
    reservation.get('status', false) === 'confirmed' &&
    !(
      (['op', 'amazon_pay'].includes(reservation.getIn(['payment', 'payform_code'], false))) &&
      reservation.getIn(['payment', 'state'], false) === 'pending'
    )
  );

  return {
    promoCodePercentDiscount: promoCodePercentDiscount,
    reservationRequest: store.getIn(["customer","reservation_request"]),
    reservation: reservation.size > 0 && isNotFinallyConfirmed ? reservation : undefined,
    lastAvailCode: queryParams && (queryParams.get('promotion_code') || queryParams.get('avail_code')),
    companyCode: companyCode,
    amountPromoPaid: amountPromoPaid,
    promoDescription: promoDescription
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, ownProps, stateProps, dispatchProps, {
    postPromotionCode: dispatchProps.postPromotionCode(stateProps.reservation, stateProps.lastAvailCode, ownProps.type,stateProps.reservationRequest)
  });
};

const mapDispatchToProps = dispatch => {
  return {
    postPromotionCode: (reservation, lastAvailCode, type, reservationRequest) => newPromoCode => {
      let value = Map({ tracking_id: reservation.get('tracking_id') });
      const currentAvailCodeType = reservation.get("avail_code_type", null);

      if (reservation.getIn(['promotion', 'code'], null)) { //promotion code
        value = value.set('promotion_code', reservation.getIn(['promotion', 'code']));
      }
      if (reservation.getIn(['gift_voucher', 'code'], null)) { // gift voucher
        value = value.set('gift_voucher', reservation.getIn(['gift_voucher', 'code']));
      }
      if (reservationRequest.getIn(['loyalty'], null)) { // loyalty
        value = value.set('loyalty', reservationRequest.getIn(['loyalty']));
      }

      if (reservationRequest.getIn(['client'], null)) { // corporate
        value = value.set('client', reservationRequest.getIn(['client']));
      }

      const restoreParam = Map().set(type, lastAvailCode);
      value = value.set(type, newPromoCode);
      if (!newPromoCode && type === currentAvailCodeType) {
        value = value.set("avail_code", newPromoCode);
      }

      //enviem la petició per validar q el promo code sigui aplicable
      return dispatch(customerActions.reservation.postAsync(value, false))
        .then(() => {
          //si el codi promocional es aplicable actualitzem els parametres, demanem dispo i li fem el parse
          dispatch(actions.customer.params.updateParams(value.delete("tracking_id")));
          return Promise.all([
            dispatch(actions.avail.getAvailAsync()),
          ]).then(() => {
            dispatch(actions.avail.getAvailParsed());
            //busquem la coincidencia amb de la reserva amb la la nova dispo, si tot va bé actualitzem url amb el nou avail_code
            return dispatch(customerActions.reservationRequest.refreshBlocks())
              .then(() => {
                dispatch(actions.router.update());
                window.document.body.scrollTop = window.document.documentElement.scrollTop = 0;
                return { success: true };
              })
              .catch(() => {
                //si falla, restaurem el promo code anterior i actualitzem la ultima url valida de dispo
                dispatch(actions.customer.params.updateParams(restoreParam));
                return Promise.all([
                  dispatch(actions.avail.getAvailAsync()),
                ]).then(() => {
                  //tornem a realitzar el post de reserva per deixarla a l'estat anterior i mostrem error
                  dispatch(
                    customerActions.reservation.postAsync(
                      Map({ tracking_id: reservation.get('tracking_id') }).set(type, null),
                      false
                    )
                  );
                  return Promise.reject(Error({ success: false, error: type + ' error' }));
                });
              });
          });
          //si el codi promocional no es aplicable deixem mostrem l'error
        })
        .catch(error => {
          return Promise.reject(error || Error({ success: false, error: type + ' not aplicable' }));
        });
    }
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
  ),
  PropertyManager([
    'validatePromotionCode',
    'cleanPromoCodeErrors',
    'reservation',
    'reservationRequest',
    'promoCodePercentDiscount',
    'companyCode',
    'postPromotionCode',
    'amountPromoPaid',
    'promoDescription',
    'type'
  ]),
  withThemeJSS({ styleFile, link: true })
)(
  class PromotionCodeForm extends React.Component {
    static displayName = 'CustomerForm';

    constructor(props) {
      super(props);
      this.state = {
        promoCodeError: false,
        loading: false
      };
    }

    overridePromoCode = ({ inputList, model, value }) => {

      const input = inputList[this.props.config.type]; 

      if(!model) {

        input.onChange(null, true);
        inputList = set([this.props.config.type, 'value'], null, inputList);

        return inputList;
      }
      
      return false;
    };

    cleanPromoCodeErrors = () => {
      if (this.state.promoCodeError) {
        this.setState({ promoCodeError: false });
      }
    };

    validatePromotionCode = (validForm, inputList) => {
      this.setState({ promoCodeError: false, loading: true });
      return this.props.config
        .postPromotionCode(inputList[this.props.config.type].value)
        .then(() => {
          return true;
        })
        .catch(error => {
          this.setState({ promoCodeError: true });
          return error;
        }).tap(() => {
          this.setState({ loading: false });
        });
    };

    render() {
      const { config, theme } = this.props;
      const { classes } = theme.styles;
      const { cleanPromoCodeErrors, reservation, promoCodePercentDiscount, companyCode, amountPromoPaid, promoDescription } = config;
      const type = this.props.config.type;
      const attribute = type === 'promotion_code' ? 'promotion' : 'gift_voucher';
      const text = type === 'promotion_code' ? 'código promocional' : 'tarjeta regalo';
      const error = type === 'promotion_code' ? 'Error al aplicar código promocional' : 'Error al aplicar tarjeta regalo';
      const icon = type === 'promotion_code' ? 'promotionalCode' : 'giftCard';
      return (
        (!companyCode || type !== 'promotion_code') && (
          <div className={classes.promotionCod}>
            <RichText innerStyle={[classes.title,classes.promotionalCodeTitle]} translate={true} ucFirst={true}>
              {'_%' + text + '%_'}
            </RichText>
            <Form
              formContext={"promotion" === attribute && attribute}
              withoutForm={true}
              onSubmit={this.validatePromotionCode}
              onChange={cleanPromoCodeErrors}
              onOverrideValues={this.overridePromoCode}
              overrideAfterChange={true}
              submitAfterOverride={true}>
              <div className={classes.promoContainer}>
                <Image innerStyle={classes.promoCodeIcon} svg={icon} />
                <label className={classes.promoCodeBox}>
                  <InputField
                    model={this.props.config.type}
                    validationsFields={{ field: 'apellidos' }}
                    css={{ invalid: null, valid: null }}
                    defaultValue={reservation.getIn([attribute, 'code'], '')}
                    validations={[{ type: 'required', isValid: '', invalidText: '' }]}
                    innerStyle={[classes.inputPromo]}
                    disabled={!!reservation.getIn([attribute, 'code'], false)}
                  />
                  <RichText
                    innerStyle={[classes.insertCode]}
                    ucFirst={true}
                    text={'_%insertar ' + text + '%_'}
                    translate={true}
                  />
                  <span className={classes.submitButtonContainer}>
                    {reservation.getIn([attribute, 'code'], false) ? (
                      this.state.loading ?
                        <Image innerStyle={classes.loadingPromoCodeSvg} svg={'loadingSvg'} />
                        :
                        <ButtonOverride
                        disableOnError={true}
                          icon={{
                            content: '',
                            innerStyle: ['gold', 'size25']
                          }}
                          innerStyle={[classes.correctCodeButton]}
                        />
                    ) : (
                        this.state.loading ?
                          <Image innerStyle={classes.loadingPromoCodeSvg} svg={'loadingSvg'} />
                          :
                          <ButtonSubmit
                            disableOnError={true}
                            richText={{
                              text: '_%aplicar%_',
                              translate: true,
                              innerStyle: ['toggleSecondButton', 'capitalize']
                            }}
                            innerStyle={['toggleSecondButton', classes.promoCodeButton]}
                          />
                      )}
                  </span>
                </label>
                <InputNotify model={type} css={{ invalid: null, valid: null }} />
                {this.state.promoCodeError && (
                  <RichText translate={true} ucFirst={true} innerStyle={[classes.promotionCodeError]} text={error}/>
                )}
                {(promoCodePercentDiscount && type === 'promotion_code') || (amountPromoPaid > 0 && type === 'gift_voucher' && reservation.getIn([attribute, 'code'], '') !== '') ? (
                  <div className={classes.rightCode}>
                    <Icon innerStyle={[classes.promoCodeDiscount]} unicodeContent={'e046'} />
                    {
                      promoDescription ? (
                        <RichText innerStyle={classes.promoCodeDiscount}>
                          {promoDescription}
                        </RichText>) : (
                          <RichText translate={true} ucFirst={true} innerStyle={classes.promoCodeDiscount}>
                            _%descuento aplicado de%_
                        </RichText>)
                    }
                    {
                      amountPromoPaid > 0 && type === 'gift_voucher' ? (
                        <Price innerStyle={['promoCodeDiscount']} amount={amountPromoPaid} />
                      ) : (
                          <span className={classes.promoCodeDiscount}>{promoCodePercentDiscount + '%'}</span>
                        )
                    }
                  </div>
                ) : null}
              </div>
            </Form>
          </div>
        )
      );
    }
  }
);
